import { render, staticRenderFns } from "./common-message.vue?vue&type=template&id=10d99474&scoped=true&"
import script from "./common-message.vue?vue&type=script&lang=js&"
export * from "./common-message.vue?vue&type=script&lang=js&"
import style0 from "./common-message.vue?vue&type=style&index=0&id=10d99474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d99474",
  null
  
)

export default component.exports